function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["citationId", "citationPrefix", "href", "linkType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useEffect, useId } from 'react';
import styled from 'styled-components';
import { useCitations } from "./CitationsContext.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
var CitationNumber = styled.sup.withConfig({
  componentId: "sc-deg363-0"
})(["margin:0 1px;vertical-align:super;font-size:smaller;"]);

/**
 * @typedef {object} Props
 * @property {string} [citationId] An optional identifier, used to ensure duplicate citations are not listed.
 * @property {string} [citationPrefix] If the `href` prop is prefixed with this, the link will render as a superscript citation number.
 * If the prefix is not present, it will be rendered as a normal link instead of a citation.
 *
 * Omit this prop to always render as a superscript citation number.
 * @property {React.ComponentType} [linkType] The component to use for links in chatbot messages. Defaults to an anchor tag.
 */

/**
 * @param {React.HTMLProps<React.ElementRef<'a'>> & Props} props
 */
var Citation = function Citation(_ref) {
  var citationId = _ref.citationId,
    citationPrefix = _ref.citationPrefix,
    _ref$href = _ref.href,
    _href = _ref$href === void 0 ? '' : _ref$href,
    LinkType = _ref.linkType,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useCitations = useCitations(),
    addCitation = _useCitations.addCitation,
    removeCitation = _useCitations.removeCitation,
    getCitationNumber = _useCitations.getCitationNumber;
  var id = useId();
  var isCitation = !citationPrefix || _href.startsWith(citationPrefix);
  var href = isCitation ? _href.replace(citationPrefix, '') : _href;
  var _id = citationId !== null && citationId !== void 0 ? citationId : id;
  var citation = _objectSpread({
    _id: _id,
    href: href
  }, props);
  useEffect(function () {
    if (isCitation) {
      addCitation(citation);
      return function () {
        return removeCitation(_id);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, isCitation, href]);
  if (!isCitation) {
    return LinkType ? /*#__PURE__*/_jsx(LinkType, _objectSpread(_objectSpread({
      href: href
    }, props), {}, {
      children: props.children
    })) : /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
      href: href,
      rel: "noreferrer noopener",
      target: "_blank"
    }, props), {}, {
      children: props.children
    }));
  }
  var index = getCitationNumber(citation);
  if (!index) {
    return null;
  }
  return /*#__PURE__*/_jsx(CitationNumber, {
    children: LinkType ? /*#__PURE__*/_jsx(LinkType, _objectSpread(_objectSpread({
      href: href
    }, props), {}, {
      children: index
    })) : /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
      href: href,
      rel: "noreferrer noopener",
      target: "_blank"
    }, props), {}, {
      children: index
    }))
  });
};
export default Citation;